"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareTaskStatus = void 0;
const parse_task_status_1 = require("./parse-task-status");
/**
 * Compare Task statuses.
 * @param a The Task status to compare.
 * @param b Another Task status to compare.
 * @returns Determines if the provided statuses match.
 */
function compareTaskStatus(a, b) {
    // parse status for cases where workflow was renamed (e.g. status log)
    return a === b || parse_task_status_1.parseTaskStatus(a) === parse_task_status_1.parseTaskStatus(b);
}
exports.compareTaskStatus = compareTaskStatus;
//# sourceMappingURL=compare-task-status.js.map